import { skipToken } from '@reduxjs/toolkit/dist/query';
import { notification } from 'antd';
import { userContext } from 'contexts/UserContext';
import { DateTime } from 'luxon';
import { useContext, useMemo, useState } from 'react';
import { accountsService } from 'services';
import { User } from 'types';
import { useLingui } from '@lingui/react/macro';
import { useSubscriptions } from './useSubscriptions';

const SHOW_BEFORE_DAYS = 5;

export function useCheckBalance() {
  const { t } = useLingui();
  const { user }: { user: User | null } = useContext(userContext);
  const [date] = useState(() => DateTime.local());

  const isShouldCheck = useMemo(() => {
    const nextMonth = DateTime.local().plus({ month: 1 }).startOf('month');
    return nextMonth.minus({ days: SHOW_BEFORE_DAYS }) <= date;
  }, [date]);

  const userIdParam = useMemo(
    () => (isShouldCheck && user ? user.Id : skipToken),
    [isShouldCheck, user]
  );

  const { totalAmount } = useSubscriptions(userIdParam);

  const { data, isSuccess } = accountsService.useBalanceQuery(userIdParam);

  useMemo(() => {
    if (!isShouldCheck) return;
    if (isSuccess && data.Balance < totalAmount) {
      notification.warn({
        message: t`Вам необходимо пополнить баланс лицевого счета для бесперебойной работы системы GSM мониторинга`
      });
    }
  }, [data?.Balance, isShouldCheck, isSuccess, t, totalAmount]);
}
